import { useCallback, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

// Natural pixel bounds of the bottle inside hero.webp (1264x848).
const NAT = { w: 1264, h: 848, x0: 705, x1: 915, y0: 45, y1: 770, posX: 0.62 };
const SIZE = 220;
const ZOOM = 2;

export function useHeroLens(imgRef) {
  const [lens, setLens] = useState(null);
  const onMove = useCallback((e) => {
    const img = imgRef.current;
    if (!img || !window.matchMedia("(hover: hover) and (min-width: 1024px)").matches) return;
    const r = img.getBoundingClientRect();
    const s = Math.max(r.width / NAT.w, r.height / NAT.h);
    const nx = (e.clientX - r.left - (r.width - NAT.w * s) * NAT.posX) / s;
    const ny = (e.clientY - r.top - (r.height - NAT.h * s) * 0.5) / s;
    if (nx < NAT.x0 || nx > NAT.x1 || ny < NAT.y0 || ny > NAT.y1) { setLens(null); return; }
    const z = s * ZOOM;
    setLens({ x: e.clientX, y: e.clientY, bw: NAT.w * z, bh: NAT.h * z, bx: SIZE / 2 - nx * z, by: SIZE / 2 - ny * z });
  }, [imgRef]);
  const hide = useCallback(() => setLens(null), []);
  return { lens, onMove, hide };
}

export const HeroLens = ({ lens, src }) => (
  <AnimatePresence>
    {lens && (
      <motion.div aria-hidden="true" data-testid="hero-label-lens"
        initial={{ opacity: 0, scale: 0.6 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.6 }} transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
        className="pointer-events-none fixed z-40 rounded-full border border-[#B18A4A] shadow-[0_30px_60px_-20px_rgba(0,0,0,.6),inset_0_0_0_6px_rgba(248,243,233,.12)]"
        style={{ width: SIZE, height: SIZE, left: lens.x - SIZE / 2, top: lens.y - SIZE / 2, backgroundImage: `url(${src})`, backgroundRepeat: "no-repeat",
          backgroundSize: `${lens.bw}px ${lens.bh}px`, backgroundPosition: `${lens.bx}px ${lens.by}px` }} />
    )}
  </AnimatePresence>
);
